export default __webpack_public_path__ + "static/media/lavanya.d9b50933.png";